
import './AddProfileButton.scss';
export default function AddProfileButton(props: any) {
    return (
        <label aria-label="Add Profile" onClick={() => {
            if (props.onClick) {
                props.onClick();
            }
        }} role="button" className="sc-gVyKpa sc-kQsIoO jgYtlS form-label profile-avatar-appear-done profile-avatar-enter-done thisone" tabIndex={0} data-gv2elementkey="addProfileButton" data-gv2interactionkey="addProfileButton" data-testid="add-profile-cta" data-gv2-interaction-bound="true">
            <div className="sc-gPzReC hHuDEQ add-profile">
                <svg aria-hidden="true" aria-label="plus" color="white" role="img" transform="" version="1.1" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" className="sc-bRBYWo kOMoAG">
                    <title>
                    </title>
                    <path d="M16.469 17.219V5.5a1 1 0 0 1 1-1h.312a1 1 0 0 1 1 1v11.719H30.5a1 1 0 0 1 1 1v.312a1 1 0 0 1-1 1H18.781V31.25a1 1 0 0 1-1 1h-.312a1 1 0 0 1-1-1V19.531H4.75a1 1 0 0 1-1-1v-.312a1 1 0 0 1 1-1h11.719z" className="sc-Rmtcm kaMwXS">
                    </path>
                </svg>
            </div>
            <h3 className="text-color--secondary padding--top-6" style={{ "maxWidth": "160px" }}>Add Profile</h3>
        </label>
    );
}